<!-- 库存商品列表 -->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
            </div>
        </div>
        <template>
            <div class="table-ctn goodlist-table">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border=""
                    style="width: 100%"
                    @cell-dblclick="handleDBClick"
                    @sort-change="sortChange"
                    :tableCode="tableCode"
                    empty-text="暂无相关库存商品信息"
                    v-loading="loading"
                >
                    <el-table-column
                        v-if="columnShowSets.APCode.IsShow"
                        :width="columnShowSets.APCode.Width > 0 ? columnShowSets.APCode.Width + 'px' : '260px'"
                        :label="columnShowSets.APCode.ColumnName"
                        prop="APCode"
                        sortable="custom"
                        fixed="left"
                        show-overflow-tooltip
                    >
                        <template slot="header">
                            {{ columnShowSets.APCode.ColumnName }}
                        </template>
                        <template slot-scope="scope"> <el-tag class="tag" type="warning">已删除</el-tag>{{ scope.row.APCode }} </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.GoodCode.IsShow"
                        :min-width="columnShowSets.GoodCode.Width > 0 ? columnShowSets.GoodCode.Width + 'px' : '200px'"
                        :label="columnShowSets.GoodCode.ColumnName"
                        prop="GoodCode"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.GoodName.IsShow"
                        :min-width="columnShowSets.GoodName.Width > 0 ? columnShowSets.GoodName.Width + 'px' : '150px'"
                        :label="columnShowSets.GoodName.ColumnName"
                        prop="GoodName"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.AutoSerise.IsShow"
                        :width="columnShowSets.AutoSerise.Width > 0 ? columnShowSets.AutoSerise.Width + 'px' : '250px'"
                        :label="columnShowSets.AutoSerise.ColumnName"
                        prop="AutoSerise"
                        sortable="custom"
                        show-overflow-tooltip
                    >
                        <template slot="header">
                            {{ columnShowSets.AutoSerise.ColumnName }}
                        </template>
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.SeriesCount > 0 || scope.row.IsCommonSeries" type="danger" effect="plain" size="small" style="padding: 0 2px">{{
                                scope.row.IsCommonSeries ? '通用' : scope.row.SeriesCount
                            }}</el-tag>
                            {{ scope.row.AutoSerise }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.CostPrice.IsShow"
                        :min-width="columnShowSets.CostPrice.Width > 0 ? columnShowSets.CostPrice.Width + 'px' : '110px'"
                        :label="columnShowSets.CostPrice.ColumnName"
                        prop="CostPrice"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Price.IsShow"
                        :min-width="columnShowSets.Price.Width > 0 ? columnShowSets.Price.Width + 'px' : '110px'"
                        :label="columnShowSets.Price.ColumnName"
                        prop="Price"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.MarketPrice.IsShow"
                        :min-width="columnShowSets.MarketPrice.Width > 0 ? columnShowSets.MarketPrice.Width + 'px' : '110px'"
                        :label="columnShowSets.MarketPrice.ColumnName"
                        prop="MarketPrice"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Inventory.IsShow"
                        :min-width="columnShowSets.Inventory.Width > 0 ? columnShowSets.Inventory.Width + 'px' : '80px'"
                        :label="columnShowSets.Inventory.ColumnName"
                        prop="Inventory"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.SpaceInvens.IsShow"
                        :width="columnShowSets.SpaceInvens.Width > 0 ? columnShowSets.SpaceInvens.Width + 'px' : '80px'"
                        :label="columnShowSets.SpaceInvens.ColumnName"
                        prop="SpaceInvens"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>{{ scope.row.SpaceInvens }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Unit.IsShow"
                        :min-width="columnShowSets.Unit.Width > 0 ? columnShowSets.Unit.Width + 'px' : '60px'"
                        :label="columnShowSets.Unit.ColumnName"
                        prop="Unit"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Cate.IsShow"
                        :min-width="columnShowSets.Cate.Width > 0 ? columnShowSets.Cate.Width + 'px' : '100px'"
                        :label="columnShowSets.Cate.ColumnName"
                        prop="Cate"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Brand.IsShow"
                        :min-width="columnShowSets.Brand.Width > 0 ? columnShowSets.Brand.Width + 'px' : '120px'"
                        :label="columnShowSets.Brand.ColumnName"
                        prop="Brand"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Origin.IsShow"
                        :min-width="columnShowSets.Origin.Width > 0 ? columnShowSets.Origin.Width + 'px' : '120px'"
                        :label="columnShowSets.Origin.ColumnName"
                        prop="Origin"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="Quality"
                        sortable="custom"
                        v-if="columnShowSets.Quality.IsShow"
                        :min-width="columnShowSets.Quality.Width > 0 ? columnShowSets.Quality.Width + 'px' : '80px'"
                        :label="columnShowSets.Quality.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Size.IsShow"
                        :min-width="columnShowSets.Size.Width > 0 ? columnShowSets.Size.Width + 'px' : '140px'"
                        :label="columnShowSets.Size.ColumnName"
                        prop="Size"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Size2.IsShow"
                        :min-width="columnShowSets.Size2.Width > 0 ? columnShowSets.Size2.Width + 'px' : '140px'"
                        :label="columnShowSets.Size2.ColumnName"
                        prop="Size2"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="Texture"
                        v-if="columnShowSets.Texture.IsShow"
                        :min-width="columnShowSets.Texture.Width > 0 ? columnShowSets.Texture.Width + 'px' : '100px'"
                        :label="columnShowSets.Texture.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="Color"
                        v-if="columnShowSets.Color.IsShow"
                        :min-width="columnShowSets.Color.Width > 0 ? columnShowSets.Color.Width + 'px' : '100px'"
                        :label="columnShowSets.Color.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="GoodDesc"
                        v-if="columnShowSets.GoodDesc.IsShow"
                        :min-width="columnShowSets.GoodDesc.Width > 0 ? columnShowSets.GoodDesc.Width + 'px' : '200px'"
                        :label="columnShowSets.GoodDesc.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.UpdateTime.IsShow"
                        :min-width="columnShowSets.UpdateTime.Width > 0 ? columnShowSets.UpdateTime.Width + 'px' : '160px'"
                        :label="columnShowSets.UpdateTime.ColumnName"
                        prop="UpdateTime"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="CreateTime"
                        sortable="custom"
                        v-if="columnShowSets.CreateTime.IsShow"
                        :min-width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                        :label="columnShowSets.CreateTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column fixed="right" label="操作" :isCanSet="true" width="80">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="recoverGoods(scope.row)" style="color: red" v-if="permission.recover">{{
                                    permission.recover
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog
            :close-on-click-modal="false"
            title="库存商品搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-goods-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item :label="searchShowSets.JointSearch.Title" v-if="searchShowSets.JointSearch.IsShow">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            size="small"
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.APCode.Title" v-if="searchShowSets.APCode.IsShow">
                        <el-input
                            @focus="selectAutoHandle('search_1')"
                            ref="search_1"
                            class="search-item"
                            size="small"
                            v-model="searchData.APCode"
                            :placeholder="searchShowSets.APCode.Placeholder"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.GoodName.Title" v-if="searchShowSets.GoodName.IsShow">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            :placeholder="searchShowSets.GoodName.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.AutoSerise.Title" v-if="searchShowSets.AutoSerise.IsShow">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            :placeholder="searchShowSets.AutoSerise.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Invent.Title" v-if="searchShowSets.Invent.IsShow">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_4"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent1"
                                @focus="selectAutoHandle('search_4')"
                            ></el-input>
                            <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.BrandId.Title" v-if="searchShowSets.BrandId.IsShow">
                        <el-select
                            ref="search_5"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Cate.Title" v-if="searchShowSets.Cate.IsShow">
                        <el-select
                            ref="search_6"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.SpaceType.Title" v-if="searchShowSets.SpaceType.IsShow">
                        <el-select ref="search_7" multiple size="small" class="search-item" style="width: 100%" v-model="searchData.SpaceType">
                            <el-option key="0" label="标准仓" value="0"></el-option>
                            <el-option key="1" label="临时仓" value="1"></el-option>
                            <el-option key="2" label="废品仓" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.GoodDesc.Title" v-if="searchShowSets.GoodDesc.IsShow">
                        <el-input
                            @focus="selectAutoHandle('search_8')"
                            ref="search_8"
                            class="search-item"
                            size="small"
                            v-model="searchData.GoodDesc"
                            :placeholder="searchShowSets.GoodDesc.Placeholder"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Size.Title" v-if="searchShowSets.Size.IsShow">
                        <el-input
                            @focus="selectAutoHandle('search_9')"
                            ref="search_9"
                            class="search-item"
                            size="small"
                            v-model="searchData.Size"
                            :placeholder="searchShowSets.Size.Placeholder"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.MarketPrice.Title" v-if="searchShowSets.MarketPrice.IsShow">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol1" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_10"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.MarketPrice1"
                                @focus="selectAutoHandle('search_10')"
                            ></el-input>
                            <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.MarketPrice2" v-if="searchData.Symbol1 == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Price.Title" v-if="searchShowSets.Price.IsShow">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol2" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_11"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Price1"
                                @focus="selectAutoHandle('search_11')"
                            ></el-input>
                            <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Price2" v-if="searchData.Symbol2 == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.CostPrice.Title" v-if="searchShowSets.CostPrice.IsShow">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol3" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_12"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.CostPrice1"
                                @focus="selectAutoHandle('search_12')"
                            ></el-input>
                            <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.CostPrice2" v-if="searchData.Symbol3 == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </div>
            </div>
        </el-dialog>
        <!--    新增库存  已经弃用  -->
        <transInventory :goodsId="EntpTempGoodsIdEdit" v-if="addAPVisible" :dialogFormVisible="addAPVisible" @closeDialog="closeAddAPDialog"></transInventory>
        <!--    查看库存    -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :edit="false" :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="校准库存数" :visible.sync="CorrectInvenVisible" width="1200px">
            <div class="dialog-content" v-if="CorrectInvenVisible">
                <correctInventories @closeDialog="closeCorrectInventories"></correctInventories>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        APMsg,
        breadcrumb,
        elTableColumn
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    if (this.$refs.search_0) {
                        this.$refs.search_0.focus();
                        this.searchIndex = 0;
                    }
                });
            }
        }
    },
    data() {
        return {
            tableCode: 'GoodsTable',
            loading: false,
            isStopReq: false,
            isStopChildReq: false,
            isStartSearch: false,
            isCanConverAP: false,
            searchIndex: 0,
            goodsMsg: {},
            multipleSelection: [],
            EntpTempGoodsIdEdit: '',
            brand: [],
            choosedGood: {},
            typeList1: [],
            addAPVisible: false, //新增
            APMsgVisible: false, //编辑
            downloadUrl: this.$util.QN_URL_BASE,
            searchData: {
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Symbol1: '',
                MarketPrice1: 0,
                MarketPrice2: 0,
                Symbol2: '',
                Price1: 0,
                Price2: 0,
                Symbol3: '',
                CostPrice1: 0,
                CostPrice2: 0,
                AutoSerise: '',
                Size: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                GoodDesc: '',
                SpaceType: [],
                page: 1,
                limit: 15,
                SearchType: 2
            },
            dialogTitle: '新增汽配', //dialog标题
            dialogVisible: false,
            searchSetVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            CorrectInvenVisible: false,
            columnShowSets: {
                APCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodName: { ColumnName: '', IsShow: false, Width: 0 },
                AutoSerise: { ColumnName: '', IsShow: false, Width: 0 },
                CostPrice: { ColumnName: '', IsShow: false, Width: 0 },
                Price: { ColumnName: '', IsShow: false, Width: 0 },
                MarketPrice: { ColumnName: '', IsShow: false, Width: 0 },
                Inventory: { ColumnName: '', IsShow: false, Width: 0 },
                Unit: { ColumnName: '', IsShow: false, Width: 0 },
                Cate: { ColumnName: '', IsShow: false, Width: 0 },
                Brand: { ColumnName: '', IsShow: false, Width: 0 },
                Origin: { ColumnName: '', IsShow: false, Width: 0 },
                Quality: { ColumnName: '', IsShow: false, Width: 0 },
                Size: { ColumnName: '', IsShow: false, Width: 0 },
                Size2: { ColumnName: '', IsShow: false, Width: 0 },
                Texture: { ColumnName: '', IsShow: false, Width: 0 },
                Color: { ColumnName: '', IsShow: false, Width: 0 },
                GoodDesc: { ColumnName: '', IsShow: false, Width: 0 },
                UpdateTime: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 },
                SpaceInvens: { ColumnName: '', IsShow: false, Width: 0 }
            },
            searchShowSets: {
                JointSearch: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                APCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                GoodName: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                AutoSerise: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                SpaceType: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                BrandId: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Cate: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                GoodDesc: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Invent: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Size: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                MarketPrice: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Price: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                CostPrice: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                }
            },
            separator: '',
            goodNameOptions: [],
            autoSeriseOptions: [],
            canSearch: true,
            srcList: [],
            showViewer: false
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        if (this.tableCode) this.getSetsData();
        this.getSearchCrtSetsData();
        this.getJointSearchSets();
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.permission = this.$util.getPermission('GoodsRecover');
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //按下一页、上一页、重新查询的时候，停下子接口的查询
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            if (key === 13) {
                e.preventDefault();
                if (
                    (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                    (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                    (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                    (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                    (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible) &&
                    that.canSearch
                ) {
                    that.handleSearch();
                }
                that.canSearch = true;
                that.isStartSearch = false;
            }
            //ESC
            if (key === 27) {
                that.canSearch = true;
                that.showViewer = false;
                if ((that.$refs.search_2 && that.$refs.search_2.suggestionVisible) || (that.$refs.search_3 && that.$refs.search_3.suggestionVisible)) {
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                e.preventDefault();
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                }
            }
            //右键
            if (key === 39) {
                if (!this.dialogVisible && !that.showViewer) {
                    e.preventDefault();
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);

                    if (page < totalPages) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //左键
            if (key === 37) {
                if (!that.dialogVisible && !that.showViewer) {
                    e.preventDefault();
                    if (that.searchData.page !== 1) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                e.preventDefault();
                if (!that.searchSetVisible && !that.APMsgVisible) {
                    if (that.dialogVisible) {
                        if (that.searchIndex != 12) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6 || that.searchIndex == 7) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex += 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    }
                    return;
                }
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                e.preventDefault();
                if (!that.searchSetVisible && !that.APMsgVisible) {
                    if (that.dialogVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6 || that.searchIndex == 7) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex -= 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    }
                    return;
                }
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        // 配件信息
        showAPMsgDialog(id) {
            this.EntpTempGoodsIdEdit = id;
            this.APMsgVisible = true;
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        searchGoodsBrand() {
            if (this.brand.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .finally(() => {});
        },
        searchGoodsType() {
            if (this.typeList1.length > 0) return;
            this.$util
                .searchDelGoodsType()
                .then(data => {
                    this.typeList1 = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                JointSearch: '',
                Symbol: '',
                AutoSerise: '',
                Size: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                GoodDesc: '',
                Invent1: 0,
                Invent2: 0,
                SpaceType: [],
                page: 1,
                limit: this.commonPageSize,
                SearchType: 2
            };
        },
        // 恢复汽配
        recoverGoods(item) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要恢复该汽配吗?',
                noMsg: true,
                confirm() {
                    that.checkAPCode(item.APCode).then(() => {
                        if (!that.isCanConverAP) {
                            that.$prompt('检测要已经有相同的配件编码，请先输入新编码', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                inputValue: item.APCode
                            })
                                .then(({ value }) => {
                                    that.$util
                                        .axiosPost({
                                            url: '/api/EntpGoods/RecoverEnterprisePart',
                                            data: {
                                                EntpTempGoodsId: item.EntpTempGoodsId,
                                                APCode: value
                                            }
                                        })
                                        .then(() => {
                                            that.$util.successMsg('恢复成功');
                                            that.getTableData();
                                        })
                                        .catch(() => {});
                                })
                                .catch(() => {});
                        } else {
                            that.$util
                                .axiosPost({
                                    url: '/api/EntpGoods/RecoverEnterprisePart',
                                    data: {
                                        EntpTempGoodsId: item.EntpTempGoodsId,
                                        APCode: ''
                                    }
                                })
                                .then(() => {
                                    that.$util.successMsg('恢复成功');
                                    that.getTableData();
                                })
                                .catch(() => {});
                        }
                    });
                }
            });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        // 获取数据
        getTableData() {
            if (!this.isStopReq) {
                if (this.searchData.Symbol) {
                    //''空值isNan 也是返会false 所以要加parseInt做强制转换
                    if (this.searchData.Symbol == 'between') {
                        if (isNaN(parseInt(this.searchData.Invent1))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                        if (isNaN(parseInt(this.searchData.Invent2))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    } else {
                        if (isNaN(parseInt(this.searchData.Invent1))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    }
                } else {
                    this.searchData.Invent1 = 0;
                    this.searchData.Invent2 = 0;
                }
                this.loading = true;
                this.isStopReq = true;
                this.isStopChildReq = false;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoods/GetEnterpriseDelPartList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;
                        if (!data) {
                            this.tableData = [];
                            return;
                        }
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.isStopReq = false;
                        this.loading = false;
                    });
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.EntpTempGoodsId) {
                this.showAPMsgDialog(event.EntpTempGoodsId);
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        searchSets() {
            if (this.tableCode) {
                this.searchSetVisible = true;
            }
        },
        closeDialog(isEdit) {
            this.searchSetVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'APCode':
                            this.columnShowSets.APCode.IsShow = item.IsShow;
                            this.columnShowSets.APCode.Width = item.Width;
                            this.columnShowSets.APCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodCode':
                            this.columnShowSets.GoodCode.IsShow = item.IsShow;
                            this.columnShowSets.GoodCode.Width = item.Width;
                            this.columnShowSets.GoodCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodName':
                            this.columnShowSets.GoodName.IsShow = item.IsShow;
                            this.columnShowSets.GoodName.Width = item.Width;
                            this.columnShowSets.GoodName.ColumnName = item.ColumnName;
                            break;
                        case 'AutoSerise':
                            this.columnShowSets.AutoSerise.IsShow = item.IsShow;
                            this.columnShowSets.AutoSerise.Width = item.Width;
                            this.columnShowSets.AutoSerise.ColumnName = item.ColumnName;
                            break;
                        case 'CostPrice':
                            this.columnShowSets.CostPrice.IsShow = item.IsShow;
                            this.columnShowSets.CostPrice.Width = item.Width;
                            this.columnShowSets.CostPrice.ColumnName = item.ColumnName;
                            break;
                        case 'Price':
                            this.columnShowSets.Price.IsShow = item.IsShow;
                            this.columnShowSets.Price.Width = item.Width;
                            this.columnShowSets.Price.ColumnName = item.ColumnName;
                            break;
                        case 'MarketPrice':
                            this.columnShowSets.MarketPrice.IsShow = item.IsShow;
                            this.columnShowSets.MarketPrice.Width = item.Width;
                            this.columnShowSets.MarketPrice.ColumnName = item.ColumnName;
                            break;
                        case 'Inventory':
                            this.columnShowSets.Inventory.IsShow = item.IsShow;
                            this.columnShowSets.Inventory.Width = item.Width;
                            this.columnShowSets.Inventory.ColumnName = item.ColumnName;
                            break;
                        case 'SpaceInvens':
                            this.columnShowSets.SpaceInvens.IsShow = item.IsShow;
                            this.columnShowSets.SpaceInvens.Width = item.Width;
                            this.columnShowSets.SpaceInvens.ColumnName = item.ColumnName;
                            break;
                        case 'Unit':
                            this.columnShowSets.Unit.IsShow = item.IsShow;
                            this.columnShowSets.Unit.Width = item.Width;
                            this.columnShowSets.Unit.ColumnName = item.ColumnName;
                            break;
                        case 'Cate':
                            this.columnShowSets.Cate.IsShow = item.IsShow;
                            this.columnShowSets.Cate.Width = item.Width;
                            this.columnShowSets.Cate.ColumnName = item.ColumnName;
                            break;
                        case 'Brand':
                            this.columnShowSets.Brand.IsShow = item.IsShow;
                            this.columnShowSets.Brand.Width = item.Width;
                            this.columnShowSets.Brand.ColumnName = item.ColumnName;
                            break;
                        case 'Origin':
                            this.columnShowSets.Origin.IsShow = item.IsShow;
                            this.columnShowSets.Origin.Width = item.Width;
                            this.columnShowSets.Origin.ColumnName = item.ColumnName;
                            break;
                        case 'Quality':
                            this.columnShowSets.Quality.IsShow = item.IsShow;
                            this.columnShowSets.Quality.Width = item.Width;
                            this.columnShowSets.Quality.ColumnName = item.ColumnName;
                            break;
                        case 'Size':
                            this.columnShowSets.Size.IsShow = item.IsShow;
                            this.columnShowSets.Size.Width = item.Width;
                            this.columnShowSets.Size.ColumnName = item.ColumnName;
                            break;
                        case 'Size2':
                            this.columnShowSets.Size2.IsShow = item.IsShow;
                            this.columnShowSets.Size2.Width = item.Width;
                            this.columnShowSets.Size2.ColumnName = item.ColumnName;
                            break;
                        case 'Texture':
                            this.columnShowSets.Texture.IsShow = item.IsShow;
                            this.columnShowSets.Texture.Width = item.Width;
                            this.columnShowSets.Texture.ColumnName = item.ColumnName;
                            break;
                        case 'Color':
                            this.columnShowSets.Color.IsShow = item.IsShow;
                            this.columnShowSets.Color.Width = item.Width;
                            this.columnShowSets.Color.ColumnName = item.ColumnName;
                            break;
                        case 'GoodDesc':
                            this.columnShowSets.GoodDesc.IsShow = item.IsShow;
                            this.columnShowSets.GoodDesc.Width = item.Width;
                            this.columnShowSets.GoodDesc.ColumnName = item.ColumnName;
                            break;
                        case 'UpdateTime':
                            this.columnShowSets.UpdateTime.IsShow = item.IsShow;
                            this.columnShowSets.UpdateTime.Width = item.Width;
                            this.columnShowSets.UpdateTime.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        getSearchCrtSetsData() {
            this.$util.getSearchCrtSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.SearchCode) {
                        case 'JointSearch':
                            this.searchShowSets.JointSearch.IsShow = item.IsShow;
                            this.searchShowSets.JointSearch.Width = item.Width;
                            this.searchShowSets.JointSearch.Placeholder = item.Placeholder;
                            this.searchShowSets.JointSearch.Title = item.Title;
                            this.searchShowSets.JointSearch.SortNum = item.SortNum;
                            break;
                        case 'APCode':
                            this.searchShowSets.APCode.IsShow = item.IsShow;
                            this.searchShowSets.APCode.Width = item.Width;
                            this.searchShowSets.APCode.Placeholder = item.Placeholder;
                            this.searchShowSets.APCode.Title = item.Title;
                            this.searchShowSets.APCode.SortNum = item.SortNum;
                            break;
                        case 'GoodName':
                            this.searchShowSets.GoodName.IsShow = item.IsShow;
                            this.searchShowSets.GoodName.Width = item.Width;
                            this.searchShowSets.GoodName.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodName.Title = item.Title;
                            this.searchShowSets.GoodName.SortNum = item.SortNum;
                            break;
                        case 'AutoSerise':
                            this.searchShowSets.AutoSerise.IsShow = item.IsShow;
                            this.searchShowSets.AutoSerise.Width = item.Width;
                            this.searchShowSets.AutoSerise.Placeholder = item.Placeholder;
                            this.searchShowSets.AutoSerise.Title = item.Title;
                            this.searchShowSets.AutoSerise.SortNum = item.SortNum;
                            break;
                        case 'SpaceType':
                            this.searchShowSets.SpaceType.IsShow = item.IsShow;
                            this.searchShowSets.SpaceType.Width = item.Width;
                            this.searchShowSets.SpaceType.Placeholder = item.Placeholder;
                            this.searchShowSets.SpaceType.Title = item.Title;
                            this.searchShowSets.SpaceType.SortNum = item.SortNum;
                            break;
                        case 'BrandId':
                            this.searchShowSets.BrandId.IsShow = item.IsShow;
                            this.searchShowSets.BrandId.Width = item.Width;
                            this.searchShowSets.BrandId.Placeholder = item.Placeholder;
                            this.searchShowSets.BrandId.Title = item.Title;
                            this.searchShowSets.BrandId.SortNum = item.SortNum;
                            break;
                        case 'Cate':
                            this.searchShowSets.Cate.IsShow = item.IsShow;
                            this.searchShowSets.Cate.Width = item.Width;
                            this.searchShowSets.Cate.Placeholder = item.Placeholder;
                            this.searchShowSets.Cate.Title = item.Title;
                            this.searchShowSets.Cate.SortNum = item.SortNum;
                            break;
                        case 'GoodDesc':
                            this.searchShowSets.GoodDesc.IsShow = item.IsShow;
                            this.searchShowSets.GoodDesc.Width = item.Width;
                            this.searchShowSets.GoodDesc.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodDesc.Title = item.Title;
                            this.searchShowSets.GoodDesc.SortNum = item.SortNum;
                            break;
                        case 'Invent':
                            this.searchShowSets.Invent.IsShow = item.IsShow;
                            this.searchShowSets.Invent.Width = item.Width;
                            this.searchShowSets.Invent.Placeholder = item.Placeholder;
                            this.searchShowSets.Invent.Title = item.Title;
                            this.searchShowSets.Invent.SortNum = item.SortNum;
                            break;
                        case 'Size':
                            this.searchShowSets.Size.IsShow = item.IsShow;
                            this.searchShowSets.Size.Width = item.Width;
                            this.searchShowSets.Size.Placeholder = item.Placeholder;
                            this.searchShowSets.Size.Title = item.Title;
                            this.searchShowSets.Size.SortNum = item.SortNum;
                            break;
                        case 'MarketPrice':
                            this.searchShowSets.MarketPrice.IsShow = item.IsShow;
                            this.searchShowSets.MarketPrice.Width = item.Width;
                            this.searchShowSets.MarketPrice.Placeholder = item.Placeholder;
                            this.searchShowSets.MarketPrice.Title = item.Title;
                            this.searchShowSets.MarketPrice.SortNum = item.SortNum;
                            break;
                        case 'Price':
                            this.searchShowSets.Price.IsShow = item.IsShow;
                            this.searchShowSets.Price.Width = item.Width;
                            this.searchShowSets.Price.Placeholder = item.Placeholder;
                            this.searchShowSets.Price.Title = item.Title;
                            this.searchShowSets.Price.SortNum = item.SortNum;
                            break;
                        case 'CostPrice':
                            this.searchShowSets.CostPrice.IsShow = item.IsShow;
                            this.searchShowSets.CostPrice.Width = item.Width;
                            this.searchShowSets.CostPrice.Placeholder = item.Placeholder;
                            this.searchShowSets.CostPrice.Title = item.Title;
                            this.searchShowSets.CostPrice.SortNum = item.SortNum;
                            break;
                    }
                });
            });
        },
        searchGoodName(key, cb) {
            this.$util.searchPartAttr(key, 1, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = arr;
                if (cb) {
                    cb(this.goodNameOptions);
                }
            });
        },
        searchAutoSerise(key, cb) {
            this.$util.searchPartAttr(key, 2, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = arr;
                if (cb) {
                    cb(this.autoSeriseOptions);
                }
            });
        },
        stopSearch() {
            this.canSearch = false;
        },
        // 校验编码是否重复
        checkAPCode(apcode) {
            let that = this;
            return new Promise((resolve, reject) => {
                that.$util
                    .axiosGet({
                        url: '/api/EntpGoods/ValidateEnterprisePartCode',
                        data: {
                            APCode: apcode
                        },
                    })
                    .then(res => {
                        if (res.data) {
                            that.isCanConverAP = false;
                        }
                        resolve();
                    });
            });
        }
    }
};
</script>
<style lang="less" scoped>
#search-goods-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.tag {
    height: 24px;
    line-height: 22px;
    margin-right: 8px;
}
</style>
<style lang="less">
.el-autocomplete-suggestion {
    width: 300px !important;
}
</style>
